export interface DocumentLink {
  id: string;
  name: string;
  path: string;
}

const REFERENCE =
  /([^\s();]+)\s*\(\s*([^,()]+)\s*,\s*(document_[\w]+|file_[\w]+)\s*,\s*(\d+)\)/g;

/**
 * Old answers cite passages as `quote (file name, file_id, page)`. Each
 * citation whose document link is known becomes a Markdown link to that
 * document at the page; the rest is left as it is.
 */
export function linkLegacyReferences(
  response: string,
  messageId: string | number,
  documentLinks: DocumentLink[],
): string {
  return response
    .split('\n')
    .map(line => {
      return line.replace(
        REFERENCE,
        (full, quotedText, _name, fileId, page) => {
          const file = documentLinks.find(item => item.id === fileId);
          if (!file?.name || !file?.path) return full;
          const quote = String(quotedText).trim();
          return `${quote} (Pg ${page}, [${file.name}](${file.path}&id=${fileId}&page=${page}&msg_id=${messageId}&ref=${encodeURIComponent(quote)}))`;
        },
      );
    })
    .join('\n');
}
